import React from 'react';
import { Star } from 'lucide-react';

const googleReviews = [
  {
    name: 'Jesus Gonzalez',
    date: '6 months ago',
    text: 'Tim is a great guy, I bought a washer and dryer set they came to set it up the next day. They stay true to their warranty and will replace the unit if it’s not working correctly. Highly recommend.'
  },
  {
    name: 'Amanda Lenton',
    date: '2 years ago',
    text: 'Cannot recommend this company enough! I messaged them at 1:15 because my dryer was electric and my new house needed gas. They were here in 1 hour, installed a used dryer to match my washer, and hauled off my old dryer too! Friendly, fast, efficient and affordable!'
  },
  {
    name: 'Patrick Van Damme',
    date: '2 years ago',
    text: 'Just bought a washing machine from them off of OfferUp. He responded quickly and delivered that same day. The two gentlemen installed and took my old washing machine away. They were courteous and professional. Would buy from this company again, and the price was great.'
  },
  {
    name: 'Alexa Knox',
    date: '2 years ago',
    text: 'Great experience!! They sent me pictures of the inventory to choose from and installed and delivered the washer and dryer the next day! They made sure both the washer and dryer worked before I paid. Also has a 90 day warranty! Amazing service!'
  },
  {
    name: 'Ryan Herkimer',
    date: '1 year ago',
    text: 'Vholic Appliances is amazing! They offer great prices for quality appliances. I reached out to Peter at 4:30pm and had an entire setup in my home by 5:30pm. Couldn’t be more pleased with the service and working washer and dryer. Highly recommend!'
  },
  {
    name: 'Robert Thorsan',
    date: '1 year ago',
    text: 'Great price and they do a very nice job of refurbishing used appliances. They deliver fast and with very clean appliances. Tested before you pay as well.'
  },
  {
    name: 'Nhi Nguyen',
    date: '1 year ago',
    text: 'I wish I knew about this place years ago. Tim was super helpful, prices are fantastic, and they even deliver. Great experience! Highly recommend.'
  },
  {
    name: 'Allen Croissant',
    date: '1 year ago',
    text: 'Brought the dryer out same day. Functions great, and has a warranty. Works for me.'
  }
];

export function GoogleReviewsCarousel() {
  return (
    <section className="overflow-hidden bg-gray-50 py-16" aria-labelledby="google-reviews-heading">
      <style>{`
        @keyframes google-reviews-slide-right {
          from {
            transform: translate3d(-50%, 0, 0);
          }
          to {
            transform: translate3d(0, 0, 0);
          }
        }

        .google-reviews-track {
          display: flex;
          width: max-content;
          animation: google-reviews-slide-right 110s linear infinite;
          will-change: transform;
        }

        .google-reviews-track:hover,
        .google-reviews-track:focus-within {
          animation-play-state: paused;
        }

        .google-review-card {
          width: min(82vw, 360px);
        }

        @media (max-width: 640px) {
          .google-reviews-track {
            animation-duration: 90s;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .google-reviews-viewport {
            overflow-x: auto;
            scrollbar-width: none;
          }

          .google-reviews-viewport::-webkit-scrollbar {
            display: none;
          }

          .google-reviews-track {
            animation: none;
            transform: none;
          }

          .google-reviews-track > div:nth-child(2) {
            display: none;
          }
        }
      `}</style>

      <div className="container mx-auto px-4 text-center">
        <h2 id="google-reviews-heading" className="mx-auto max-w-3xl text-2xl font-semibold text-gray-900 md:text-3xl">
          Feedback from customers who purchased appliances from Vholic Appliances.
        </h2>
      </div>

      <div className="google-reviews-viewport relative mt-12 overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-gray-50 to-transparent md:w-24" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-gray-50 to-transparent md:w-24" />

        <div className="google-reviews-track">
          {[0, 1].map((groupIndex) => (
            <div
              key={groupIndex}
              className="flex shrink-0 items-stretch gap-6 pr-6"
              aria-hidden={groupIndex === 1 ? true : undefined}
            >
              {googleReviews.map((review) => (
                <article
                  key={`${groupIndex}-${review.name}`}
                  className="google-review-card flex h-full shrink-0 flex-col rounded-2xl border border-gray-200 bg-white p-6 text-left shadow-sm"
                >
                  <div className="mb-5 flex items-center justify-between gap-4">
                    <div className="flex" aria-label="5 out of 5 stars">
                      {[...Array(5)].map((_, index) => (
                        <Star
                          key={index}
                          className="h-5 w-5 fill-current text-yellow-400"
                          aria-hidden="true"
                        />
                      ))}
                    </div>
                    <span className="inline-flex items-center gap-2 text-xs font-semibold text-gray-500">
                      <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-gray-200 bg-white font-bold text-blue-600">
                        G
                      </span>
                      Google Review
                    </span>
                  </div>

                  <p className="flex-1 leading-7 text-gray-700">“{review.text}”</p>

                  <div className="mt-6 border-t border-gray-100 pt-4">
                    <p className="font-semibold text-gray-900">{review.name}</p>
                    <p className="mt-1 text-sm text-gray-500">{review.date}</p>
                  </div>
                </article>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
